function checkMobile(size) {
  return window.innerWidth <= size;
}

function isMobile() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
    || checkMobile(576)
  ) {
    return true;
  }
  return false;
}

function checkIfItsBetweenSizes(min, max) {
  return window.innerWidth >= min && window.innerWidth <= max;
}

function isTablet() {
  return checkIfItsBetweenSizes(376, 768);
}

export {
  // eslint-disable-next-line import/prefer-default-export
  isMobile, checkMobile, isTablet,
};
